/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * The `type` field determines the type of card to issue. It can be either a physical card or a virtual card.

A physical card is a traditional, tangible card that is made of plastic or other materials and can be used for both online and in-person transactions at retail card terminals.

A virtual card is a digital / online only version of a payment card, which can be used for online transactions or for transactions made through a mobile device when binding to wallets or payment apps.
 */
export type IssueCardBodyType = typeof IssueCardBodyType[keyof typeof IssueCardBodyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IssueCardBodyType = {
  physical: 'physical',
  virtual: 'virtual',
} as const;
